import questionnaire from "./questionnaire";


const questionnaireService = [
    {
        matcher: /questionnaire\/(.*)/,
        reply: config => {
            const id = /questionnaire\/(.*)/.exec(config.url)[1];
            return [200, questionnaire];
        }
    }
]

export default questionnaireService;